//SHARED FILE : USED ON DETAILS AND PRODUCT LIST
//ANY CHANGES SHOULD BE TESTED ON BOTH PAGES
$(function(){
	//idea board
      $('.faveLink').on('click', function(e) {
		e.preventDefault();
		var favIcon = $(this).closest('.favPrintIcons');
		$('.cancelBoardList').click();
		if(favIcon.hasClass('mobileList')){
			//mobile site product list page
			favIcon.find('.ideaBoardList').css({ 'z-index' : '1000', 'width' : '250px', 'margin-top' : '40px', 'left' : '30%' }).slideDown('fast');
		} else if(favIcon.hasClass('mobileDetails')){
			//mobile site details page
			favIcon.find('.ideaBoardList').css({ 'z-index' : '1000', 'top' : '210px', 'width' : '290px'}).slideDown('fast');
		} else {
			//main site
			favIcon.find('.ideaBoardList').css({ 'z-index' : '1000', 'top' : '270px', 'width' : '290px'}).slideDown('fast');
		}
	}); 
	
	$('.faveLink').on('keypress', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	
	$('.cancelBoardList').on('click', function(e) {
		e.preventDefault();
		$(this).closest('.favPrintIcons').find('.ideaBoardList').slideUp('fast');
		$('.addToBoardMsg').each(function(){
			$(this).remove();
		});
	});
	
	$('.cancelBoardList').on('keypress', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	
	 $('.boardName').on('click', function(e) {
		e.preventDefault();
		$('.addToBoardMsg').remove();
		//$(this).siblings('.addToBoardMsg').slideUp('fast').remove();
		AddToIdeaBoard(this);
	});
	
	$('.boardName').on('keypress', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	}); 
	
	 $('.saveAsFavBoard').on('click', function(e) {
	 	e.preventDefault();
	 	$('.cancel-new-board').click();
		$('.newBoardMsg').remove();
		if($(this).hasClass('registered')){
			GetBoardForm();			
		}				
	});
	
	$('.saveAsFavBoard').on('keypress', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	
	$('body').on('click', '.cancel-delete-item', function(e) {
		e.preventDefault();
		$(this).closest('.addToBoardMsg').slideUp('fast').remove();
	});
	
	$('body').on('keypress', ' .cancel-delete-item',  function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});

	//add cart items to existing board	
	$('body').on('click', '.boardListItem', function(e) {
		e.preventDefault();
		$('.addToBoardMsg').remove();
		AddCartItemsToBoard(this);
	});
	
	$('body').on('keypress', ' .boardListItem',  function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	
	$('body').on('click', '.confirm-delete-item', function(e) {
		e.preventDefault();
		var arr = $(this).attr('href').split('/');
		DeleteBoardItem(arr[0], arr[1], this);
	});
	
	$('body').on('keypress', '.confirm-delete-item', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	
     $('body').on('click', '.cancel-new-board' , function () { 
		var form = $(this).closest('#newBoardForm');		
		form.addClass('slideLeft');
		form.find('.ErrorMsgPanel').slideUp('slow');
		form.find('#BoardName').removeAttr('style');
		//remove board after the animation has had time to play
		setTimeout(function() {
			form.remove();
		  },250);
		$('.create-board').attr('aria-expanded', 'false').focus();
		$('.saveAsFavBoard').focus();
    });

     //keypress event listener
    $('body').on('keypress', '.cancel-new-board' , function (e) {  
    		ClickOnKeyPress(this, e);
    }); 
    
     $('body').on('click', '#submitNewBoard' , function () {  		    		
    		var form = $(this).closest('#newBoardForm');
    		form.find('.ErrorMsgPanel').remove();
    		var boardName = form.find('#BoardName');
    		if(boardName.val() == ''){
    			boardName.css('background-color', 'rgb(255, 217, 217)');
    			var temp = GetValidationTemplate();
    			temp =  temp.replace('##ERRORLIST##', '<li class="boardNameError"><a href="#" tabindex="0" role="link"><span>Please enter a Board Name</span></a><li/>');   			
    			form.find('.newBoardHdr').before(temp);
    			form.find('#ErrorMsgBox li:last-child').remove();
    			boardName.focus();
    			return false;  		
    		}
    		CreateBoardWithCart(this);
    });

     //keypress event listener
    $('body').on('keypress', '#submitNewBoard' , function (e) {  
    		ClickOnKeyPress(this, e);
    }); 
    
    //trap focus tab in open dialog on cart page
    $('body').on('keydown', 'a.boardListItem:last', function(e){
    		if(e.which == 9){
    			e.preventDefault();
 			$('.cancel-new-board.icon-closeX').focus();
	 	}
    })

   //remove error messages
    $('body').on('keyup', 'input.boardName' , function () { 
    	   if (this.value != '') {
		var form = $(this).closest('#newBoardForm');
		if(form.length == 0){
			form = $(this).closest('#editBoardForm');
			if(form.length == 0){
				form = $(this).closest('#sharingPanel');
			}
		}
		
		form.find('.ErrorMsgPanel').slideUp(700).remove();
		form.find('.boardName').removeAttr('style');	
		form.find('#shareEmail').removeAttr('style');		
	   }
    });   
    
    //add to idea board
    function AddToIdeaBoard(e){
       d = $(e).siblings('.board-id').val();
       var productID = (typeof(prodID) == 'undefined') ? $(e).closest('.favPrintIcons').find('input.faveLinkProdID').val() : prodID;
              
       if(productID == null){
       	//still not found? try mobile details
       	productID = $('#productid').val();
       }
       
    	var data = { boardID: d, productID: productID };
        $.ajax({
            url: "/favs/additemtoboard",
            type: "POST",
            data: JSON.stringify(data),
            beforeSend: function (req) {
                $(e).siblings('.addItemLoading').fadeIn('fast');
            },
            complete: function (req) {
                $(e).siblings('.addItemLoading').fadeOut('fast');
            },
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                //If the user is able to place a sample request display the sample request form otherwise let them know when they are not able to.
                $(e).after((result.message));
                if(result.success == "true"){
                	$(e).closest('.favPrintIcons').find('.faveLink').removeClass('textDkGray').addClass('textRed');
                }
            }
        });
    }
    
    function DeleteBoardItem(e, f, g){
	var boardID = e;
	var boardItemID = f;	
	var data = {	boardID: boardID, boardItemID : boardItemID };
	
	$.ajax({
            url: '/favs/deleteboarditem',
            type: "POST",
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: "application/json",
            beforeSend: function () {
                $(g).siblings('.addItemLoading').fadeIn('fast');
            },
            complete: function(result){
            	   $(g).siblings('.addItemLoading').fadeOut('fast');
            },
            success: function (result) { 
                	$(g).closest('.addToBoardMsg').slideUp('fast').remove();
                	if(result.isItemInOtherBoards == "False"){
                		$(e).closest('.favPrintIcons').find('.faveLink').removeClass('textRed').addClass('textDkGray');
                	}
            },           
            error: function (result) {
               
            }
       });
    }
    
function GetBoardForm(){	
	$.ajax({
            url: '/favs/getcartboardform',
            type: "POST",
            dataType: 'html',
            contentType: "application/json",
            beforeSend: function () {
                $("#loading").removeClass("hide");
            },
            complete: function(result){
            	   $("#loading").addClass("hide");
            },
            success: function (result) {
            		$('#divCartTable').append(result);
             		$('#newBoardForm').slideDown();
             		$('#BoardName').focus();             		
            },
            error: function (result) {
                
            }
       });

}    

function CreateBoardWithCart(e){
	var form = $(e).closest('.boardTemplate');
	var boardName = form.find('#BoardName').val();
	var isDefaultBoard = form.find('#IsDefaultBoard').is(':checked');
	var note = form.find('#Notes').val();
	var cartID = $('#UserCart_CartID').val();
	var data = {	BoardName: boardName, CreatedDate : null, GURID: '', IsDefaultBoard: isDefaultBoard, Notes: note, CartID: cartID	};
	
	$.ajax({
            url: '/favs/addnewboard',
            type: "POST",
            data: JSON.stringify(data),
            dataType: 'html',
            contentType: "application/json",
            beforeSend: function () {
                
            },
            success: function (result) {          		           
              	var rt = $.parseHTML(result);
            		if(rt.length > 1){
            			//$('.cancel-new-board').click();
              		$('#newBoardForm').replaceWith(result);
              		$('.newBoardMsg').focus();
            		}
            		$('.ErrorMsgPanel').remove();
            		var boardName = form.find('#BoardName');
            		boardName.css('background-color', 'rgb(255, 217, 217)');
    			var temp = GetValidationTemplate();
    			temp =  temp.replace('##ERRORLIST##', '<li><a href="#" tabindex="0" role="link"><span>' + result + '</span></a><li/>');   			
    			form.find('.existingBoardHdr').after(temp);
    			form.find('#ErrorMsgBox li:last-child').remove();
    			boardName.focus();
              	
             },
            error: function (result) {
                
            }
       });
}

    //add to idea board
function AddCartItemsToBoard(e){
       var boardID = $(e).siblings('.board-id').val();
       var cartID = $('#UserCart_CartID').val();
       
    	var data = { cartID: cartID, boardID: boardID };
    	
       $.ajax({
            url: "/favs/addcartitemstoboard",
            type: "POST",
            data: JSON.stringify(data),
            beforeSend: function (req) {
                $(e).siblings('.addItemLoading').fadeIn('fast');
            },
            complete: function (req) {
                $(e).siblings('.addItemLoading').fadeOut('fast');
            },
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                 $(e).after((result.message));
            }
        });
}
    
 function GetValidationTemplate(){
	template = 
	     '<div class="ErrorMsgPanel text12 validation-summary-errors textDkRed clear" id="ErrorBox" role="alert">' +
               	 '<p class="paddingTop10 text14 semibold marginLeft10 validationHeading textDkRed" id="ErrorTitle">Oops! Some of the information you entered is not correct.</p>' +
                	 '<div class="textDkRed" id="ErrorMsgBox">' +
                   		'<ul class="text14">##ERRORLIST##</ul>' +
             	  	 '</div>' +
             	'</div>';
	return template;
}

function ClickOnKeyPress(trig, e){
	if(e.which == 13){
 		$(trig).click();
	 }
}
    //end add to idea board
});